export default __webpack_public_path__ + "static/media/borndyed.3281ee67.svg";